export const DELIVERY_LOCATION_STORAGE_KEY = 'hunar_delivery_location';

const hasBrowserStorage = () => typeof window !== 'undefined' && window.localStorage;

const clean = (value) => String(value || '').trim();

export const normalizeDeliveryLocation = (location = {}) => ({
  id: location.id ? Number(location.id) : null,
  nickname: clean(location.nickname),
  address: clean(location.address),
  city: clean(location.city),
  state: clean(location.state),
  zip: clean(location.zip),
  country: clean(location.country) || 'India',
  detectedLabel: clean(location.detectedLabel),
  source: clean(location.source) || 'manual',
  verificationStatus: clean(location.verificationStatus || location.verification_status),
  verificationNote: clean(location.verificationNote || location.verification_note),
  isDefault: Boolean(location.isDefault ?? location.is_default),
  coordinates: location.coordinates && Number.isFinite(Number(location.coordinates.latitude)) && Number.isFinite(Number(location.coordinates.longitude))
    ? {
        latitude: Number(location.coordinates.latitude),
        longitude: Number(location.coordinates.longitude),
      }
    : null,
});

export const readSavedDeliveryLocation = () => {
  if (!hasBrowserStorage()) return null;

  try {
    const stored = window.localStorage.getItem(DELIVERY_LOCATION_STORAGE_KEY);
    if (!stored) return null;
    const parsed = normalizeDeliveryLocation(JSON.parse(stored));
    return parsed.address || parsed.city || parsed.zip ? parsed : null;
  } catch {
    return null;
  }
};

export const saveDeliveryLocation = (location) => {
  const normalized = normalizeDeliveryLocation(location);
  if (!hasBrowserStorage()) return normalized;

  window.localStorage.setItem(DELIVERY_LOCATION_STORAGE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new CustomEvent('hunar:delivery-location-updated', { detail: normalized }));
  return normalized;
};

export const clearSavedDeliveryLocation = () => {
  if (!hasBrowserStorage()) return;
  window.localStorage.removeItem(DELIVERY_LOCATION_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent('hunar:delivery-location-updated', { detail: null }));
};

export const reverseGeocodeCoordinates = async ({ latitude, longitude }, signal) => {
  const query = new URLSearchParams({
    format: 'jsonv2',
    addressdetails: '1',
    zoom: '18',
    lat: String(latitude),
    lon: String(longitude),
  });
  const response = await fetch(`https://nominatim.openstreetmap.org/reverse?${query.toString()}`, {
    headers: { 'Accept-Language': 'en' },
    signal,
  });
  if (!response.ok) throw new Error('Address lookup failed.');

  const data = await response.json();
  const address = data.address || {};
  const street = [address.house_number, address.road || address.pedestrian || address.neighbourhood]
    .filter(Boolean)
    .join(' ');

  return normalizeDeliveryLocation({
    address: street || data.display_name,
    city: address.city || address.town || address.village || address.municipality,
    state: address.state || address.state_district,
    zip: address.postcode,
    country: address.country || 'India',
    detectedLabel: data.display_name,
    source: 'browser',
    coordinates: { latitude, longitude },
  });
};
